// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__1TJQD","barcodesTable":"Sidebar_barcodesTable__2yVLk"};